import React, { Component } from "react";
import { Box } from "reactjs-admin-lte";
import { Pagination, Form, FormGroup, Button } from "react-bootstrap";
import { momentHelper } from "../helpers";
import SelectDate from "component/element/SelectDate";
import Select from "react-select";
import PrintButtons from "component/element/PrintButtons";
import ReportStore from "stores/ReportStore";
import XLSX from "xlsx";
import FileSaver from "file-saver";
import FontAwesome from "react-fontawesome";
import DatePicker from "component/element/DatePicker";
import IframeModal from "component/element/IframeModal";
import Moment from "moment";

import "../report.css";
// import { connect } from 'react-redux';
const tableDetail = {
  cost_supply: [
    {
      label: "วันที่",
      field: "added_date",
      class: "text-center",
      width: "100px",
    },
    {
      label: "รายละเอียด",
      field: "description",
      class: "text-left",
      width: "200px",
    },
    { label: "จำนวน", field: "quantity", class: "text-center", width: "90px" },
    {
      label: "ต้นทุน/หน่วย",
      field: "cost_per_unit",
      class: "text-right",
      width: "100px",
      isNumberFormat: true,
    },
    {
      label: "ผู้ทำรายการ",
      field: "request_by",
      class: "text-center",
      width: "100px",
    },
    {
      label: "ผู้อนุมัติ",
      field: "response_by",
      class: "text-center",
      width: "100px",
    },
  ],
  cost_part: [
    {
      label: "วันที่",
      field: "added_date",
      class: "text-center",
      width: "100px",
    },
    {
      label: "รายละเอียด",
      field: "description",
      class: "text-left",
      width: "200px",
    },
    { label: "จำนวน", field: "quantity", class: "text-center", width: "90px" },
    {
      label: "ต้นทุน/หน่วย",
      field: "cost_per_unit",
      class: "text-right",
      width: "100px",
      isNumberFormat: true,
    },
    {
      label: "ผู้ทำรายการ",
      field: "request_by",
      class: "text-center",
      width: "100px",
    },
    {
      label: "ผู้อนุมัติ",
      field: "response_by",
      class: "text-center",
      width: "100px",
    },
  ],
  cost_purchase: [
    {
      label: "วันที่",
      field: "added_date",
      class: "text-center",
      width: "100px",
    },
    {
      label: "ชื่อร้าน",
      field: "shop_name",
      class: "text-center",
      width: "150px",
    },
    {
      label: "รายละเอียด",
      field: "description",
      class: "text-left",
      width: "200px",
    },
    {
      label: "จำนวน",
      field: "item_quantity",
      class: "text-center",
      width: "90px",
    },
    {
      label: "ราคา/หน่วย",
      field: "price_per_unit",
      class: "text-right",
      width: "100px",
      isNumberFormat: true,
    },
    {
      label: "มูลค่า",
      field: "amount",
      class: "text-center",
      width: "100px",
      isNumberFormat: true,
    },
  ],
  cost_wage: [
    {
      label: "วันที่ปิดงาน",
      field: "taskclosed_date",
      class: "text-center",
      width: "100px",
    },
    {
      label: "ชื่อช่าง",
      field: "employee_name",
      class: "text-center",
      width: "150px",
    },
    {
      label: "รายละเอียด",
      field: "description",
      class: "text-left",
      width: "200px",
    },
    {
      label: "จำนวน(ชั่วโมง)",
      field: "man_hour",
      class: "text-center",
      width: "90px",
    },
    {
      label: "ค่าแรงต่อวัน",
      field: "wage_per_day",
      class: "text-right",
      width: "100px",
      isNumberFormat: true,
    },
    {
      label: "มูลค่า",
      field: "wage_cost",
      class: "text-center",
      width: "100px",
      isNumberFormat: true,
    },
  ],
};
const WHOLE_YEAR = momentHelper.getMonth(); //'00'
class ReportJobCostSheet extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      activePage: 1,
      month: WHOLE_YEAR,
      year: momentHelper.getYear(),
      data: [],
      isRange: false,
      day: momentHelper.getDay(),
      dayRange: momentHelper.getDay(),
      monthRange: WHOLE_YEAR,
      yearRange: momentHelper.getYear(),

      type: "cost_supply",
      wo: "",
      showDetail: false,
      isSubMenu: false,
      subMenu: [],
    };
    this.refTableId = "ReportJobCostSheet-" + Math.ceil(Math.random() * 100);
    this.refTableDetailId =
      "ReportJobCostSheetDetail-" + Math.ceil(Math.random() * 100);
  }

  componentDidMount() {}

  componentWillReceiveProps(newProps) {
    if (newProps.show && newProps.show !== this.props.show) {
      this.loadReportAnalysisWorkDebitCreditInOut(
        this.state.year,
        this.state.month,
        this.state.day
      );
    }
  }

  getAllDayOfMonth(date) {
    const all_day = Moment(date, "YYYY-MM").daysInMonth();
    if (all_day) {
      if (all_day < this.state.day) {
        var defaultDay = "00";
      } else {
        var defaultDay = this.state.day;
      }
    } else {
      var defaultDay = "00";
    }
    return defaultDay;
  }

  getPercent(cost, value) {
    let sum = 0;
    if (value > 0) sum = (cost / value) * 100;
    return sum;
  }

  getNumberFormat(value) {
    let _val =
      value === "" || value === null || value === undefined || isNaN(value)
        ? 0
        : value;
    _val = parseFloat(_val);
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
  }

  getSummary(field) {
    let { data } = this.state;
    let total = 0;
    data.forEach((item, index) => {
      total +=
        item[field] === "" ||
        item[field] === null ||
        item[field] === undefined ||
        isNaN(item[field])
          ? 0
          : item[field] * 1;
    });
    return total;
  }

  getPercentSummary(field, field1) {
    let { data } = this.state;
    let total = 0;
    let total1 = 0;
    let sum = 0;
    data.forEach((item, index) => {
      total =
        item[field] === "" ||
        item[field] === null ||
        item[field] === undefined ||
        isNaN(item[field])
          ? 0
          : item[field] * 1;
      total1 =
        item[field1] === "" ||
        item[field1] === null ||
        item[field1] === undefined ||
        isNaN(item[field1])
          ? 0
          : item[field1] * 1;
      sum += this.getPercent(total, total1);
    });
    return sum;
  }

  getDetailSummary(field) {
    let { dataDetail, type } = this.state;
    let total = 0;
    if (type === "cost_wage") field = "wage_per_day";

    dataDetail.forEach((item, index) => {
      if (type === "cost_supply" || type === "cost_part") {
        total += item[field] * item["quantity"];
      } else
        total +=
          item[field] === "" ||
          item[field] === null ||
          item[field] === undefined ||
          isNaN(item[field])
            ? 0
            : item[field] * 1;
    });
    return total;
  }

  // loadData(year = "", month = "", day = "") {
  //   this.setState({ loading: true });
  //   ReportStore.loadReportJobCostSheetWork(year, month, day, (result) => {
  //     this.setState({ loading: false, data: result.data });
  //   });
  // }
  loadReportAnalysisWorkDebitCreditInOut(year = "", month = "", day = "") {
    ReportStore.loadReportAnalysisWorkDebitCreditInOut(
      year,
      month,
      day,
      (result) => {
        this.setState({ loading: false, data: result.data });
        console.log("xxxx", result);
      }
    );
  }

  loadDataRange(start = "", end = "") {
    ReportStore.loadReportJobCostSheetWorkRange(start, end, (result) => {
      this.setState({ loading: false, data: result.data });
    });
  }

  onTableDetailCloseClick() {
    this.setState(
      {
        subMenu: [],
        isSubMenu: false,
        type: "cost_supply",
        wo: "",
        showDetail: false,
        dataDetail: [],
      },
      () => {
        if (this.props.onUpdateEventKey != undefined)
          this.props.onUpdateEventKey(undefined);
      }
    );
  }

  onRowClick(item, type) {
    this.setState(
      {
        loading: true,
        wo: item.work_no,
        type: type,
        subMenu: [
          {
            title:
              (type == "cost_supply"
                ? "ต้นทุนค่าวัสดุสิ้นเปลือง"
                : type == "cost_part"
                ? "ต้นทุนค่าอะไหล่"
                : type == "cost_purchase"
                ? "ต้นทุนจัดซื้อ"
                : "") +
              " เลขที่งานซ่อม " +
              item.work_no,
            key: "s" + 0,
          },
        ],
        isSubMenu: true,
      },
      () => {
        if (this.props.onUpdateEventKey != undefined)
          this.props.onUpdateEventKey("s" + 0);
      }
    );
    ReportStore.loadReportJobCostSheetWorkDetail(
      type,
      item.work_no,
      (result) => {
        this.setState({
          loading: false,
          dataDetail: result.data,
          showDetail: true,
        });
      }
    );
  }

  renderBody() {
    let { data } = this.state;
    if (data.length == 0) {
      return (
        <tr>
          <td colSpan={14}>ไม่พบข้อมูล</td>
        </tr>
      );
    } else {
      return data.map((item, index) => {
        return (
          <tr key={index}>
            <td className="text-center">{index + 1}</td>
            <td className="text-center">{item.customer_payment_by}</td>
            <td className="text-center">{item.work_no}</td>
            <td className="text-center">{item.work_date}</td>
            <td className="text-center">{item.owner_name}</td>
            <td className="text-center">{item.car_registration_no}</td>
            <td className="text-center">{item.brand}</td>
            <td className="text-center">{item.model}</td>
            <td className="text-right">{item.excess}</td>
            <td className="text-right">{item.debit_wage}</td>
            <td className="text-right">{item.debit_part}</td>
            <td className="text-right">{item.credit_wage}</td>
            <td className="text-right">{item.credit_part}</td>
            <td className="text-right">{item.receiving_date}</td>
            <td className="text-right">{item.deleivering_date}</td>
          </tr>
        );
      });
    }
  }

  renderBodyDetail() {
    let { dataDetail, type } = this.state;
    if (dataDetail.length == 0) {
      return (
        <tr>
          <td colSpan={14}>ไม่พบข้อมูล</td>
        </tr>
      );
    } else {
      return dataDetail.map((item, index) => {
        return (
          <tr key={index}>
            <td className="text-center">{index + 1}</td>
            {tableDetail[type].map((ritem, rindex) => {
              if (ritem.isNumberFormat) {
                return (
                  <td key={rindex} className="text-right">
                    {this.getNumberFormat(item[ritem.field])}
                  </td>
                );
              } else {
                return (
                  <td key={rindex} className={ritem.class}>
                    {item[ritem.field]}
                  </td>
                );
              }
            })}
          </tr>
        );
      });
    }
  }

  getDate() {
    let {
      day,
      year,
      month,
      isRange,
      dayRange,
      monthRange,
      yearRange,
    } = this.state;
    if (isRange) {
      let start =
        (day < 10 ? "0" + day : day) +
        "/" +
        (month == "00" ? "1" : month) +
        "/" +
        year;
      let end =
        dayRange +
        "/" +
        (monthRange < 10 ? "0" + monthRange : monthRange) +
        "/" +
        yearRange;
      return "ประจำวันที่ " + start + " - " + end;
    } else {
      let text = "ประจำวันที่ ";
      text += day + " " + momentHelper.getMonthText(month) + " " + year;
      if (year === "0" || year === "00" || year === 0) {
        text = "ทั้งหมด";
      } else if (month === "0" || month === "00" || month === 0) {
        text = "ประจำปี " + year;
      } else if (day === "0" || day === "00" || day === 0) {
        text = "ประจำเดือน " + momentHelper.getMonthText(month) + " " + year;
      }
      return text;
    }
  }

  renderTable() {
    return (
      <div className="display-overflow">
        <table
          id={this.refTableId}
          className=" table table-hover table-bordered-solid"
          style={{ minWidth: "1200px" }}
        >
          <thead>
            <tr>
              <th
                style={{ display: "none" }}
                className="text-center"
                colSpan={13}
              >
                รายงาน Job Cost Sheet {this.getDate()}
              </th>
            </tr>
            <tr>
              <th rowSpan="2" className="text-center" style={{ width: "90px" }}>
                ลำดับ
              </th>
              <th rowSpan="2" className="text-center" style={{ width: "90px" }}>
                ประเภทลูกค้า
              </th>
              <th rowSpan="2" className="text-center" style={{ width: "90px" }}>
                JOB NO.
              </th>
              <th
                rowSpan="2"
                className="text-center"
                style={{ width: "100px" }}
              >
                JOB_DATE
              </th>
              <th
                colSpan="4"
                className="text-center"
                style={{ width: "110px" }}
              >
                ข้อมูลรถยนต์
              </th>
              <th colSpan="3" className="text-center" style={{ width: "90px" }}>
                เงินสด
              </th>
              <th colSpan="2" className="text-center" style={{ width: "90px" }}>
                ประกัน
              </th>
              <th
                rowSpan="2"
                className="text-center"
                style={{ width: "120px" }}
              >
                รถเข้าซ่อม
              </th>
              <th
                rowSpan="2"
                className="text-center"
                style={{ width: "100px" }}
              >
                รถออก
              </th>
            </tr>
            <tr>
              <th className="text-center">ชื่อเจ้าของรถ</th>
              <th className="text-center">ทะเบียนรถ</th>
              <th className="text-center">ยี่ห้อรถ</th>
              <th className="text-center">รุ่นรถ</th>
              <th className="text-center">ค่าExcept</th>
              <th className="text-center">ค่าแรง</th>
              <th className="text-center">ค่าอะไหล่</th>
              <th className="text-center">ค่าแรง</th>
              <th className="text-center">ค่าอะไหล่</th>
            </tr>
          </thead>
          <tbody>{this.renderBody()}</tbody>
          {}
        </table>
      </div>
    );
  }

  renderTableDetail() {
    let { type } = this.state;
    return (
      <div className="display-overflow">
        <table
          id={this.refTableDetailId}
          className="table table-responsive table-hover table-bordered-solid table-report-kkc-income"
        >
          <thead>
            <tr style={{ display: "none" }}>
              <th colSpan={3}>
                ประเภท :
                {type == "cost_supply"
                  ? "ต้นทุนค่าวัสดุสิ้นเปลือง"
                  : type == "cost_part"
                  ? "ต้นทุนค่าอะไหล่"
                  : type == "cost_purchase"
                  ? "ต้นทุนจัดซื้อ"
                  : type == "cost_wage"
                  ? "ต้นทุนค่าแรง"
                  : ""}
              </th>
              <th colSpan={4}>เลขที่งานซ่อม: {this.state.wo}</th>
            </tr>
            <tr>
              <th className="text-center" style={{ width: "50px" }}>
                ลำดับ
              </th>
              {tableDetail[type].map((item, index) => {
                return (
                  <th
                    key={index}
                    className={"text-center"}
                    style={{ width: item.width }}
                  >
                    {item.label}
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>{this.renderBodyDetail()}</tbody>
          <tfoot>
            {type === "cost_supply" || type === "cost_part" ? (
              <tr>
                <th colSpan={4} className="text-right">
                  ยอดรวมสุทธิ
                </th>
                <th className="text-right">
                  {this.getNumberFormat(this.getDetailSummary("cost_per_unit"))}
                </th>
                <th colSpan={2} className="text-right"></th>
              </tr>
            ) : (
              <tr>
                <th colSpan={6} className="text-right">
                  ยอดรวมสุทธิ
                </th>
                <th className="text-right">
                  {this.getNumberFormat(this.getDetailSummary("amount"))}
                </th>
              </tr>
            )}
          </tfoot>
        </table>
      </div>
    );
  }

  onPageSelect(eventKey) {
    this.setState({
      activePage: eventKey,
    });
    // next... load new page
  }

  onDayChange(val) {
    this.setState({
      day: val.value,
      isRange: false,
    });
    this.loadReportAnalysisWorkDebitCreditInOut(
      this.state.year,
      this.state.month,
      val.value
    );
  }

  onMonthChange(val) {
    let date = this.state.year - 543 + "-" + val.value;
    let _day = "00";
    _day = this.getAllDayOfMonth(date);
    this.setState({
      month: val.value,
      isRange: false,
      day: _day,
    });
    this.loadReportAnalysisWorkDebitCreditInOut(
      this.state.year,
      val.value,
      _day
    );
  }

  onYearChange(val) {
    let date = val.value - 543 + "-" + this.state.month;
    let _day = "00";
    _day = this.getAllDayOfMonth(date);
    this.setState({
      year: val.value,
      isRange: false,
      day: _day,
    });
    this.loadReportAnalysisWorkDebitCreditInOut(
      val.value,
      this.state.month,
      _day
    );
  }

  onCriterionChange(val) {
    this.setState({
      criterion: val.value,
    });
  }

  onExportExcel(e) {
    const worksheet = XLSX.utils.table_to_book(
      document.getElementById(this.refTableId)
    );
    let wbout = XLSX.write(worksheet, {
      bookType: "xlsx",
      bookSST: true,
      type: "binary",
    });

    function s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    }
    const fileName = "รายงาน Job Cost Sheet.xlsx";
    FileSaver.saveAs(
      new Blob([s2ab(wbout)], { type: "application/octet-stream" }),
      fileName
    );
    this.setState({ showExport: false });
  }

  onPrintTable(e) {
    const { isRange } = this.state;
    let url = "";
    let param =
      "PrintReportAnalysisWorkDebitCreditInOut&year=" +
      this.state.year +
      "&month=" +
      this.state.month +
      "&day=" +
      this.state.day +
      "&isRange=false";
    if (isRange) {
      let { day, month, year, dayRange, monthRange, yearRange } = this.state;
      let start =
        day + "/" + (month == "00" ? "1" : month) + "/" + (year - 543);
      let end = dayRange + "/" + monthRange + "/" + (yearRange - 543);
      param =
        "PrintReportAnalysisWorkDebitCreditInOut&start_date=" +
        start +
        "&end_date=" +
        end +
        "&isRange=true";
    }

    if (process.env.NODE_ENV == "development") {
      url = "./?startPage=" + param;
    } else {
      url = "./pdf/v2/?startPage=" + param;
    }
    this.refs.iframe.loadUrl(url);
  }

  onExportExcelDetail(e) {
    const worksheet = XLSX.utils.table_to_book(
      document.getElementById(this.refTableDetailId)
    );
    let wbout = XLSX.write(worksheet, {
      bookType: "xlsx",
      bookSST: true,
      type: "binary",
    });

    function s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    }
    let { type } = this.state;
    let fileName =
      "รายงาน สรุปงานซ่อมรถเข้า-ออก เงินสด/ประกัน " +
      " เลขที่งานซ่อม " +
      this.state.wo +
      ".xlsx";
    FileSaver.saveAs(
      new Blob([s2ab(wbout)], { type: "application/octet-stream" }),
      fileName
    );
    this.setState({ showExport: false });
  }

  onPrintTableDetail(e) {
    let url = "";
    let param =
      "PrintReportJobCostSheetDetail&type=" +
      this.state.type +
      "&wo=" +
      this.state.wo;
    if (process.env.NODE_ENV == "development") {
      url = "./?startPage=" + param;
    } else {
      url = "./pdf/v2/?startPage=" + param;
    }
    this.refs.iframe.loadUrl(url);
  }

  onStartDateRangeChange(time) {
    if (time != "" && time != undefined && time != null) {
      let _day = time.substr(0, 2);
      let _month = time.substr(3, 2);
      let _year = time.substr(6, 10);
      this.setState({
        day: _day * 1,
        month: _month,
        year: _year * 1,
        isRange: false,
      });
      this.loadReportAnalysisWorkDebitCreditInOut(_year, _month, _day);
    }
  }

  onEndDateRangeChange(time) {
    if (time != "" && time != undefined && time != null) {
      let { day, month, year } = this.state;
      let _day = parseInt(time.substr(0, 2));
      let _month = parseInt(time.substr(3, 5));
      let _year = parseInt(time.substr(6, 10));
      this.setState({
        isRange: true,
        dayRange: _day,
        monthRange: _month,
        yearRange: _year,
      });
      year = year - 543;
      _year = _year - 543;
      let start = day + "/" + (month == "00" ? "1" : month) + "/" + year;
      let end = _day + "/" + _month + "/" + _year;
      this.loadDataRange(start, end);
    }
  }

  onRangeChange(fromDateString, toDateString, items) {
    let { day, month, year, dayRange, monthRange, yearRange } = this.state;
    day = items.from.format("DD") * 1;
    month = items.from.format("MM");
    year = items.from.format("YYYY") * 1 + 543;
    dayRange = items.to.format("DD") * 1;
    monthRange = items.to.format("MM");
    yearRange = items.to.format("YYYY") * 1 + 543;
    this.setState({
      isRange: true,
      day: day,
      month: month,
      year: year,
      dayRange: dayRange,
      monthRange: monthRange,
      yearRange: yearRange,
    });
    const start = day + "/" + month + "/" + items.from.format("YYYY");
    const end = dayRange + "/" + monthRange + "/" + items.to.format("YYYY");
    this.loadDataRange(start, end);
  }

  renderWCalendar() {
    return (
      <div style={{ display: "inline-flex" }}>
        <DatePicker
          style={{ display: "inline-block" }}
          height={"36px"}
          none={true}
          showIcon={true}
          showFooter={true}
          popPlacement="bottom"
          buddhistEra
          value={
            (this.state.day == "00" ? momentHelper.getDay() : this.state.day) +
            "/" +
            (this.state.month == "00" ? WHOLE_YEAR : this.state.month) +
            "/" +
            this.state.year
          }
          onChange={this.onStartDateRangeChange.bind(this)}
          maxWidth={"100%"}
          onRangeChange={this.onRangeChange.bind(this)}
        />
        <DatePicker
          style={{ display: "inline-block" }}
          height={"36px"}
          none={true}
          showIcon={true}
          showFooter={true}
          popPlacement="bottom"
          buddhistEra
          value={
            (this.state.dayRange == "00"
              ? momentHelper.getDay()
              : this.state.dayRange) +
            "/" +
            (this.state.monthRange == "00"
              ? WHOLE_YEAR
              : this.state.monthRange) +
            "/" +
            this.state.yearRange
          }
          onChange={this.onEndDateRangeChange.bind(this)}
          maxWidth={"100%"}
          onRangeChange={this.onRangeChange.bind(this)}
        />
      </div>
    );
  }

  renderToolbar() {
    return (
      <Form inline>
        <FormGroup style={{ marginBottom: 10, verticalAlign: "top" }}>
          <SelectDate
            wholeYear={true}
            year={this.state.year}
            month={this.state.month}
            day={this.state.day}
            onMonthChange={this.onMonthChange.bind(this)}
            onYearChange={this.onYearChange.bind(this)}
            onDayChange={this.onDayChange.bind(this)}
            dayWCalendar={true}
            renderWCalendar={this.renderWCalendar.bind(this)}
          />
        </FormGroup>
        {/* <div
          style={{ width: "70px", display: "inline-block", marginLeft: "5px" }}
        >
          <Select
            clearable={false}
            name="form-field-name"
            value={this.state.criterion}
            options={this.state.criterionList}
            onChange={this.onCriterionChange.bind(this)}
          />
        </div> */}
        <FormGroup
          style={{
            verticalAlign: "top",
            marginLeft: "5px",
            marginTop: "1.5px",
          }}
        >
          <PrintButtons
            onPrintTable={this.onPrintTable.bind(this)}
            onExportExcel={this.onExportExcel.bind(this)}
            marginLeft="0"
            width="auto"
          />
        </FormGroup>
      </Form>
    );
  }

  renderToolbarDetail() {
    return (
      <Form inline>
        <FormGroup
          style={{
            verticalAlign: "top",
            marginTop: "1.5px",
            marginBottom: "5px",
          }}
        >
          <PrintButtons
            onPrintTable={this.onPrintTableDetail.bind(this)}
            onExportExcel={this.onExportExcelDetail.bind(this)}
            marginLeft="0"
            width="auto"
          />
        </FormGroup>
      </Form>
    );
  }

  renderPaging() {
    return (
      <div className="text-center pull-right">
        <Pagination
          prev
          next
          first
          last
          bsSize="medium"
          items={5}
          activePage={this.state.activePage}
          onSelect={this.onPageSelect.bind(this)}
        />
      </div>
    );
  }

  getStartDateRangeText() {
    let { day, month, year } = this.state;
    let txtMonth = momentHelper.getMonthText(month.toString());
    return day * 1 + " " + txtMonth + " " + year;
  }

  getEndDateRangeText() {
    let { dayRange, monthRange, yearRange } = this.state;
    dayRange = dayRange == 0 ? 1 : dayRange;
    let txtMonth = momentHelper.getMonthText(monthRange.toString());
    return dayRange + " " + txtMonth + " " + yearRange;
  }

  onRangeClearClick() {
    this.loadReportAnalysisWorkDebitCreditInOut(
      this.state.year,
      this.state.month,
      this.state.day
    );
    this.setState({
      isRange: false,
      dayRange: momentHelper.getDay(),
      monthRange: this.state.month,
      yearRange: this.state.year,
    });
  }

  renderDateRange() {
    let { isRange } = this.state;
    if (isRange) {
      return (
        <div style={{ marginBottom: "10px", display: "flex" }}>
          {this.getStartDateRangeText()} - {this.getEndDateRangeText()}&nbsp;
          <Button
            className="btn btn-xs"
            onClick={this.onRangeClearClick.bind(this)}
          >
            <FontAwesome name="eraser" />
            &nbsp;ลบช่วงเวลา
          </Button>
        </div>
      );
    } else {
      return "";
    }
  }

  render() {
    const { loading, showDetail } = this.state;
    return (
      <Box loading={loading}>
        <Box.Header border={true}>
          {this.props.renderMenu(this.state.isSubMenu, this.state.subMenu)}
        </Box.Header>
        <Box.Body>
          {showDetail ? this.renderToolbarDetail() : this.renderToolbar()}
          {!showDetail ? this.renderDateRange() : ""}
          {showDetail ? this.renderTableDetail() : this.renderTable()}
          {/* {this.renderPaging()} */}
          <IframeModal ref="iframe" title={"พิมพ์เอกสาร"} />
        </Box.Body>
        {showDetail ? (
          <Box.Footer>
            <div className=" pull-right">
              <Button
                bsStyle="default"
                onClick={this.onTableDetailCloseClick.bind(this)}
              >
                <FontAwesome name="table" />
                &nbsp;กลับหน้าตารางหลัก
              </Button>
            </div>
          </Box.Footer>
        ) : (
          ""
        )}
      </Box>
    );
  }
}

ReportJobCostSheet.defaultProps = {
  show: false,
};

export default ReportJobCostSheet;



// WEBPACK FOOTER //
// ./src/view/report/analysis/ReportAnalysisWorkDebitCreditInOut.js